import { getCurrentInstance } from 'vue';
import { Router, RouteLocationNormalizedLoaded } from 'vue-router';

export function useRouter(): Router {
  const instance = getCurrentInstance();

  if (!instance) {
    throw new Error(`Should be used in setup().`);
  }

  const router = instance.proxy?.$router;
  if (!router) {
    throw new Error('Router is not properly initialized');
  }

  return router;
}

export function useRoute(): RouteLocationNormalizedLoaded {
  const instance = getCurrentInstance();

  if (!instance) {
    throw new Error(`Should be used in setup().`);
  }

  const route = instance.proxy?.$route;
  if (!route) {
    throw new Error('Route is not properly initialized');
  }

  return route;
}
